import { dispatchHandler } from "../helpers/dispatchHandler";
import axios from "axios";
import {
  ERROR,
  GET_ALL_STRUCTURE,
  GET_MENUS,
  GET_SELECTED_MENU,
  GET_TECHNOLOGIES,
  GET_USER_PERMISSIONS,
  GET_WHOLE_STRUCTURE,
  SYSTEM_SETTINGS,
  USER_INFO,
} from "./type";
import { errorToast } from "../../helpers/Notification";
import { saveAs } from "file-saver";
import secureLocalStorage from "react-secure-storage";

const header = {
  headers: { "access-token": secureLocalStorage.getItem("token") },
};

export const systemLogin = (request) => async (dispatch) => {
  try {
    const URL = `/api/user/sign-in/`;
    const { data } = await axios.post(URL, request);
    if (data) {
      const isSuperAdmin=data?.data?.role==="superAdmin"
      secureLocalStorage.setItem("token", data.accessToken);
      secureLocalStorage.setItem("refresh-token", data.refreshToken);
      secureLocalStorage.setItem("user", JSON.stringify(data.data));
      secureLocalStorage.setItem("systemSettings", JSON.stringify(data.systemSettings));
      dispatchHandler({
        type: USER_INFO,
        data: data.data,
        dispatch,
      });
   
      if (data?.data?.isPartner) {
        window.location.href = "/admin/assigned-projects";
      }else if(isSuperAdmin){
        window.location.href = "/admin/system/settings";
      } else {
        window.location.href = "/admin/dashboard";
      }
    }
    return data;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Server Error");
    dispatchHandler({
      type: ERROR,
      data: error?.response?.data?.message,
      dispatch,
    });
    return null;
  }
};

export const submitGeneralForm =
  (URL, body, onUploadProgress) => async (dispatch) => {
    try {
      const { data } = await axios.post(URL, body, {
        ...header,
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
        },
      });
      return { data, status: true };
    } catch (error) {
      dispatchHandler({
        type: ERROR,
        data: error?.data?.message || error?.response?.data?.message,
        dispatch,
      });
      return { data: error, status: false };
    }
  };

export const getLoggedUser = () => async (dispatch) => {
  try {
    const data = JSON.parse(secureLocalStorage.getItem("user"));
    const settings = JSON.parse(secureLocalStorage.getItem("systemSettings"));

    dispatchHandler({
      type: USER_INFO,
      data: data,
      dispatch,
    });
    dispatchHandler({
      type: SYSTEM_SETTINGS,
      data: settings,
      dispatch,
    });
  } catch (error) {}
};
export const setSelectedMenu = (data) => async (dispatch) => {
  try {
    dispatchHandler({
      type: GET_SELECTED_MENU,
      data: data,
      dispatch,
    });
  } catch (error) {}
};

export const downloadBase64 =
  (id, name, type, fileType, specialName) => async () => {
    try {
      const axios_URL = `/api/download/file/${id}?type=${type}&key=${name}&specialName=${specialName}`;
      const { data } = await axios.get(axios_URL, {
        ...header,
        responseType: "blob",
      });
      if (data) {
        const file = new Blob([data], {
          type: fileType,
        });
        return await blobToBase64(file);
      }
    } catch (error) {
      return null;
    }
  };

export const generalDownload = (id, type, name, specialName) => async () => {
  try {
    const axios_URL = `/api/download/file/${id}?type=${type}&key=${name}&specialName=${specialName}`;
    const { data, headers } = await axios.get(axios_URL, {
      ...header,
      responseType: "blob",
    });
    if (data) {
      const file = new Blob([data], {
        type,
      });
      let filename = headers["content-disposition"].split("filename=").pop();
      saveAs(file, filename ?? name);
    }
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Server Error");
  }
};

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export const downloadExcelFile = (url) => async (dispatch) => {
  try {
    dispatchHandler({ type: ERROR, data: null, dispatch });

    const { data, headers } = await axios.post(
      url,
      {},
      { ...header, responseType: "blob" }
    );

    if (data) {
      const file = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
      });

      // const fileURL = URL.createObjectURL(file);
      let filename = headers["content-disposition"].split("filename=").pop();
      saveAs(file, `${filename ?? "report"}.xlsx`);
    }

    return data;
  } catch (error) {
    return null;
  }
};
export const deleteAction = (URL) => async () => {
  try {
    const { data } = await axios.delete(URL, header);
    return { data, status: true };
  } catch (error) {
    return { data: error, status: false };
  }
};

export const fetchDetails = (URL) => async (dispatch) => {
  try {

    const { data } = await axios.get(URL, header);

    return { data, status: true };
  } catch (error) {
    dispatchHandler({
      type: ERROR,
      data: error?.data?.message,
      dispatch,
    });
    return { data: error, status: false };
  }
};
export const putAction = (URL, map) => async (dispatch) => {
  try {
    const { data } = await axios.put(URL, map, header);
    return { data, status: true };
  } catch (error) {
    dispatchHandler({
      type: ERROR,
      data: error?.data?.message,
      dispatch,
    });
    return { data: error, status: false };
  }
};

export const getTechnologies = (uri) => async (dispatch) => {
  try {
    const URL = uri ?? "api/technology/get/approved";
    const { data } = await axios.get(URL, header);
    dispatchHandler({
      type: GET_TECHNOLOGIES,
      data: data.list,
      dispatch,
    });
    return { data, status: true };
  } catch (error) {
    return { data: error, status: false };
  }
};

export const getAllMenus = () => async (dispatch) => {
  try {
    const URL = "api/structure/structure/menu?type=all";
    const { data } = await axios.get(URL, header);
    dispatchHandler({
      type: GET_MENUS,
      data: data?.data,
      dispatch,
    });      


    return { data, status: true };
  } catch (error) {
    return { data: error, status: false };
  }
};

export const getUserPermissions = (resourceId) => async (dispatch) => {
  try {
    const URL = `api/permission/user?resourceId=${resourceId}&type=all`;

    const { data } = await axios.get(URL, header);

    // const actions = data?.data?.filter((item) => item?.type === "action");
    // const menus = data?.data?.filter((item) => item?.type === "menu");
    dispatchHandler({
      type: GET_USER_PERMISSIONS,
      data: data?.data,
      dispatch,
    });
    // secureLocalStorage.removeItem("userActions");
    secureLocalStorage.removeItem("userMenus");

    // secureLocalStorage.setItem("userActions", actions);
    secureLocalStorage.setItem("userMenus", data?.data);


    return { data, status: true };
  } catch (error) {
    return { data: error, status: false };
  }
};
export const getMyStructure= () => async (dispatch) => {
  try {
    const URL = "api/structure";
    const { data } = await axios.get(URL, header);

    dispatchHandler({
      type: GET_ALL_STRUCTURE,
      data: data?.data,
      dispatch,
    });
    return { data, status: true };
  } catch (error) {
    return { data: error, status: false };
  }
};
export const getWholeStructure = () => async (dispatch) => {
  try {
    const URL = "api/structure/whole-structure";
    const { data } = await axios.get(URL, header);

    dispatchHandler({
      type: GET_WHOLE_STRUCTURE,
      data: data?.data,
      dispatch,
    });
    return { data, status: true };
  } catch (error) {
    return { data: error, status: false };
  }
}